<template>
  <UserTypeView v-if="step == 1" @setType="setType"></UserTypeView>
  <TermsConditionsView v-if="step == 2"  :회원구분="member.회원구분" @setConsent="setConsent"></TermsConditionsView>
  <TotalUserDetailView v-if="step == 3" :member="member" :회원구분="member.회원구분" @setUser="setUser"></TotalUserDetailView>
  <CertificateRegistrationView v-if="step == 4" @setJoin="authJoin()"></CertificateRegistrationView>
  <CertificateApprovalView v-if="step == 5"></CertificateApprovalView>
  <authModal v-if="authFlag" @close="close" :businessno="member.사업자번호"/>
</template>

<script setup lang="ts">
import { onMounted, ref } from "vue";
import UserTypeView from "@/views/signup/UserTypeView.vue";
import TermsConditionsView from "@/views/signup/TermsConditionsView.vue";
import TotalUserDetailView from "@/views/signup/TotalUserDetailView.vue";
import CertificateRegistrationView from "@/views/signup/CertificateRegistrationView.vue";
import CertificateApprovalView from "@/views/signup/CertificateApprovalView.vue";
import authModal from "@/components/popup/authModal.vue";
import { Member, saveFile } from "@/common/types";
import userAPI from "@/api/userAPI";
import { onBeforeRouteLeave } from "vue-router";


const step = ref(1);
const member = ref<Member>({
  회원순번: 0,
  회원아이디: new Date().toISOString().slice(8, 14).replace("T", ""),
  비밀번호: new Date().toISOString().slice(8, 14).replace("T", ""),
  사업자구분: "",
  사업자번호: "",
  사업자명: "",
  대표자명: "",
  대표자전화번호: "",
  담당자명: "",
  담당자전화번호: "",
  담당자이메일: "",
  우편번호: "",
  주소: "",
  상세주소: "",
  우편번호2: "",
  주소2: "",
  상세주소2: "",
  회원구분: "",
  비고: "",
  회원연혁: "",
  수주수행구분: "",
  사업자등록증: {} as saveFile,
})
const fileData = ref<File | null>(null);
onMounted(() => {
  const date = new Date()
  const dd = String(date.getDate()).padStart(2, '0');
  const hh = String(date.getHours()).padStart(2, '0');
  const mm = String(date.getMinutes()).padStart(2, '0');

  member.value.회원아이디 = dd + "" + hh + mm
  member.value.비밀번호 = dd + "" + hh + mm

})
onBeforeRouteLeave((to, from, next) => {
  if(to.name != "singup") {
    next()
  } else {
    if (step.value > 1 && step.value < 5) {
      next(false);
      pervStep()
      // 실행시킬 함수 추가
    } else {
      next();
    }
  }
});
const setType = (type:string) => {
  member.value.회원구분 = type;
  nextStep();
}
const setConsent = () => {
    nextStep();
}
const setUser = async(data:any) => {
  
  const businessNumber = `${data.businessNumber1}-${data.businessNumber2}-${data.businessNumber3}`.replaceAll("-", "");
  const phoneNumber = `${data.phoneNumber1}-${data.phoneNumber2}-${data.phoneNumber3}`.replaceAll("-", "");
  const managerPhone = `${data.managerPhone1}-${data.managerPhone2}-${data.managerPhone3}`.replaceAll("-", "");
  const email = `${data.email1}@${data.email2}`;
  member.value = {
    ...member.value,
    사업자구분: data.businessType,
    사업자명: data.companyName,
    사업자번호: businessNumber,
    대표자명: data.representativeName,
    대표자전화번호: phoneNumber,
    담당자명: data.managerName,
    담당자전화번호: managerPhone,
    담당자이메일: email,
    우편번호: data.companyAddress1,
    주소: data.companyAddress2,
    상세주소: data.addressDetail,
    우편번호2: data.companyAddress21,
    주소2: data.companyAddress22,
    상세주소2: data.addressDetail2,
    비고: data.remarks,
  }
  fileData.value = data.file;
  
  nextStep();
}
const authFlag = ref(false);
const close = (flag: boolean) => {
  if(flag) {
    setJoin()
  }
  authFlag.value = false;
}
const authJoin = () => {
  authFlag.value = true;
}
const setJoin = async() => {
  
  const formData = new FormData();
  formData.append(
    "data",
    new Blob(
      [
        JSON.stringify(member.value),
      ],
      { type: "application/json" }
    )
  );

  if (fileData.value) {
    formData.append("사업자등록증", fileData.value);
  }

  await userAPI
    .signUp(formData)
    .then((res) => {
      if (res.data.success) {
        alert("회원가입이 성공적으로 완료되었습니다!");
      }
    })
    .catch((error) => {
      console.error("회원가입 오류:", error);
    });
    nextStep();
}
const nextStep = () => {
  console.log(member.value.회원아이디)
  step.value += 1;
  document.getElementsByClassName('contents')[0].scrollTo(0, 0);
}
const pervStep = () => {
  step.value -= 1;
  document.getElementsByClassName('contents')[0].scrollTo(0, 0);
  if(step.value == 1) {
    member.value.회원구분 = "";
  }
  if(step.value == 2) {
    fileData.value = null;
  }
}
</script>

<style scoped>
.page {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 100px;
}

.page_title {
  display: flex;
  flex-direction: row;
  width: 80%;
  align-items: center;
  font-family: "Noto Sans CJK KR-Bold";
  padding: 30px 0px;
}

.login_wrap {
  border: 0.1px solid #d0d0d0;
  width: 80%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 20px;
  height: 453px;
  border-radius: 15px;
  box-shadow: 4px 4px 8px 0px #0000000d;
}

.login_btn {
  width: 341px;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Medium";
  background: #3382e9;
  color: white;

  border-radius: 8px;
}

.join_btn {
  width: 341px;
  height: 60px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 16px;
  font-family: "Noto Sans CJK KR-Medium";
  background: #232a58;
  color: white;
  border-radius: 8px;
}

.page_header_line {
  width: 36px;
  border-bottom: 3px solid #000000;
  margin-bottom: 20px;
}

.page_header {
  padding: 80px 30px 15px 30px;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 24px;
  /* text-align: center; */
}

.description {
  text-align: center;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Light";
  color: #6d6d6d;
  margin-bottom: 40px;
}
</style>
